import { useContext } from 'react';

import { AnnotationsTooltipProps } from '../../core/components/annotations/components/tooltip/types/annotations-tooltip-props.js';
import { XAxisProps } from '../components/axis/types/annotations-x-axis-props.js';
import { AnnotationsChartConfigContext } from '../contexts/AnnotationsChartConfig.context.js';
import { AnnotationsChartConfigRequiredProps } from '../types/annotations-chart-config-props.js';
import { AnnotationsChartProps } from '../types/annotations-chart-props.js';
import {
  buildAnnotationsChartConfig,
  deserializeConfig,
  isSerializedConfig,
} from '../utils/annotations-chart-config.js';

export const useAnnotationsChartConfig = (
  props: AnnotationsChartProps,
  xAxis: XAxisProps,
  tooltip: AnnotationsTooltipProps,
  hasNumericalData: boolean,
): AnnotationsChartConfigRequiredProps => {
  const contextConfig = useContext(AnnotationsChartConfigContext);
  const config = isSerializedConfig(contextConfig)
    ? deserializeConfig(contextConfig)
    : contextConfig;

  return buildAnnotationsChartConfig(
    props,
    config,
    xAxis,
    tooltip,
    hasNumericalData,
  );
};
